import { render } from "./RequiRRHH.vue?vue&type=template&id=41a0099a"
import script from "./RequiRRHH.vue?vue&type=script&lang=js"
export * from "./RequiRRHH.vue?vue&type=script&lang=js"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__